var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseIcon',{staticClass:"my-2 mr-2",attrs:{"name":"shopping-cart","width":"30","height":"30"}}),_c('h1',[_vm._v(_vm._s(_vm.$t("Warenkorb")))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 px-1 py-1"},[_c('ShoppingCart')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }